/*eslint-disable */
// @ts-expect-error
import { jitsiLocalStorage } from '@jitsi/js-utils';
import { useMediaQuery } from '@mui/material';
import i18next from 'i18next';
import { sampleSize, shuffle } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import apiManagerRoom from '../../../api/apiManagerRoom';
import ApiManagerUser from '../../../api/ApiManagerUser';
import { checkIsJibri } from '../../../app/functions.any';
import { COMMANDS } from '../../../mod-command/constants';
import { sendCommand } from '../../../mod-command/slice';
import { setEnableSubtitle } from '../../../subtitles/actions.any';
import { setIsShowLabel } from '../../../toolbox/actions.any';
import { updateLangUser } from '../../../user/slice';
import { setTileViewMode } from '../../../video-layout/actions.any';
import { setRoomConfig } from '../../conference/actions.any';
import { setJWT } from '../../jwt/actions';
import { getJwtContext } from '../../jwt/functions';
import { getLocalParticipant, PARTICIPANT_ROLE, showWarningLimitedParticipantsRoom } from '../../participants';
import { participantJoined, participantLeft } from '../../participants/actions';
import { getHideSelfView } from '../../settings/functions.any';
import { getAccessToken, setTokens } from '../../util/cookies';
import { isDevModeOn } from '../functions';
import { parseURLParams } from '../../util';
import { reloadWithStoredParams } from '../../../app/actions.any';
import { CONFIG_CODE } from '../../constants/default';
import { setConfigGuestJoin } from '../../conference/actions.web';
import { handleGuestJoin } from '../../../prejoin/components/web/PrejoinV3.web';
import { updateSettings } from '../../settings/actions';
const HandleApp = () => {
    const dispatch = useDispatch();
    const matches = useMediaQuery('(min-width:760px)');
    const vpqhcode = parseURLParams(window.location, false, 'hash')['config.vpqhcode'];
    const clientCode = parseURLParams(window.location, false, 'hash')['config.clientCode'];
    const defaultLocalDisplayName = parseURLParams(window.location, false, 'hash')['config.defaultLocalDisplayName'];
    const clientId = parseURLParams(window.location, false, 'hash')['config.clientId'];
    const { conference, roomConfig, roomInfo } = useSelector((state) => state['features/base/conference']);
    const userManage = useSelector((state) => state['features/user-manage']);
    const mobileSettings = useSelector((state) => state['features/mobile-system']);
    const lang = userManage?.lang || mobileSettings.language;
    const { autoGuest, prejoinConfig } = useSelector((state) => state['features/base/config']);
    const { remote, remoteVideoSources } = useSelector((state) => state['features/base/participants']);
    const { lobbyEnabled } = useSelector((state) => state['features/lobby']);
    const localParticipant = useSelector(getLocalParticipant);
    const isShowLabel = useSelector((state) => state['features/toolbox'].isShowLabel);
    const disableSelfView = useSelector((state) => getHideSelfView(state));
    const { enableSubtitle } = useSelector((state) => state['features/subtitles']);
    const _isModerator = Boolean(localParticipant?.role === PARTICIPANT_ROLE.MODERATOR);
    const [fakeUsers, setFakeUsers] = useState([]);
    const [isShowMenuFake, setIsShowMenuFake] = useState(true);
    const handleAddUser = () => {
        const newUser = fakeUserInfo();
        setFakeUsers(prev => [...prev, newUser]);
        dispatch(participantJoined(newUser, true));
    };
    const handleRemoveUser = () => {
        const userRemove = fakeUsers[0];
        setFakeUsers(prev => prev.filter(p => p.id !== userRemove.id));
        dispatch(participantLeft(userRemove.id));
    };
    /**
     * Thay đổi khi có code mới
     */
    const handleAutoGuest = async () => {
        await handleGuestJoin(autoGuest);
        if (!prejoinConfig?.enabled) {
            const context = getJwtContext(getAccessToken());
            if (context) {
                dispatch(setJWT(getAccessToken()));
            }
            // Không cần
            // dispatch(updateSettings({
            //     displayName: autoGuest
            // }))
        }
    };
    /**
     * Lấy thông tin config của hệ thống
     */
    const getConfigsSystem = async () => {
        try {
            const configs = await apiManagerRoom.getConfigs();
            if (configs && configs?.data) {
                dispatch(setRoomConfig(configs?.data));
            }
        }
        catch (error) {
            console.log('[debugger] error getConfigsSystem: ', error);
        }
    };
    const getUserInfo = async () => {
        try {
            const userRes = await ApiManagerUser.getUserByToken();
            const localLang = jitsiLocalStorage.getItem('language');
            dispatch(updateLangUser(localLang || userRes?.data[0].lang));
        }
        catch (error) {
            console.log('[debugger] error getUserInfo', error);
        }
    };
    const getRefreshTokenVPQH = async () => {
        try {
            const res = await ApiManagerUser.getVPQHRefreshtoken({
                code_verifier: vpqhcode
            });
            if (res.status === 200) {
                if (!getAccessToken()) {
                    setTimeout(() => {
                        dispatch(reloadWithStoredParams());
                    }, 250);
                    setTokens(res.data.accessToken, res.data.refreshToken);
                }
            }
        }
        catch (error) {
            console.log('[Error] getRefreshToken VPQH: ', error);
        }
    };
    const getRefreshTokenClient = async () => {
        try {
            const res = await ApiManagerUser.getClientRefreshtoken(clientId, {
                code_verifier: clientCode
            });
            if (res.status === 200) {
                if (!getAccessToken()) {
                    setTimeout(() => {
                        dispatch(reloadWithStoredParams());
                    }, 250);
                    setTokens(res.data.accessToken, res.data.refreshToken);
                }
            }
        }
        catch (error) {
            console.log('[Error] getRefreshTokenClient: ', error);
        }
    };
    const getConfig = async (config) => {
        try {
            const res = await apiManagerRoom.getConfig(config);
            if (res?.status === 200) {
                dispatch(setConfigGuestJoin(res?.data[0].value === 'ON'));
            }
        }
        catch (error) {
            console.log('[Error]', error);
        }
    };
    useEffect(() => {
        if (!isShowLabel)
            dispatch(setIsShowLabel(!isShowLabel));
    }, [matches]);
    /**
     * TODO:
     * Lấy cấu hình phofnh
     * Lấy thông tin người dùng
     */
    useEffect(() => {
        if (!roomConfig)
            getConfigsSystem();
        if (!checkIsJibri()) {
            getUserInfo();
        }
        getConfig(CONFIG_CODE.GUEST_JOIN);
    }, []);
    useEffect(() => {
        if (autoGuest) {
            handleAutoGuest();
        }
    }, [autoGuest]);
    /**
     * Thay đổi ngôn ngữ
     */
    useEffect(() => {
        i18next.changeLanguage(lang);
    }, [lang]);
    /**
     * Enable lobby khi đạt giới hạn người tham gia
     */
    useEffect(() => {
        if (!lobbyEnabled &&
            _isModerator &&
            roomInfo && (remote.size - remoteVideoSources.size) + 1 >= roomInfo?.limit_users_room) {
            // dispatch(toggleLobbyMode(true))
            showWarningLimitedParticipantsRoom({ dispatch, typeWarning: 'autoEnableLobby' });
        }
    }, [remote.size, remoteVideoSources.size, _isModerator, lobbyEnabled]);
    useEffect(() => {
        if (disableSelfView && remote.size === 0) {
            const largeVideo = document.getElementById('largeVideoWrapper');
            if (largeVideo) {
                largeVideo.style.display = 'none';
            }
        }
        if (!disableSelfView || remote.size > 0) {
            const largeVideo = document.getElementById('largeVideoWrapper');
            if (largeVideo && (largeVideo.style.display === 'none' || !largeVideo.style.backgroundColor)) {
                largeVideo.style.display = 'block';
            }
        }
    }, [disableSelfView, remote.size, conference]);
    /**
     * Kiểm tra trạng thái enable livecaption của phòng họp
     */
    useEffect(() => {
        if (webSocket?.id && conference) {
            console.log('[info] Check live caption room enable...');
            webSocket.on("check_live_caption_room_server", (data) => {
                if (data == true && !enableSubtitle) {
                    dispatch(setEnableSubtitle(true));
                }
            });
        }
    }, [conference, webSocket]);
    /**
     * TODO:
     * Kiểm tra code
     * Gọi API xác thực, lấy thông tin refreshtoken
     * Set token, refreshtoken
     */
    useEffect(() => {
        if (vpqhcode)
            getRefreshTokenVPQH();
    }, [vpqhcode]);
    useEffect(() => {
        if (clientCode && clientId) {
            getRefreshTokenClient();
        }
        if (defaultLocalDisplayName) {
            dispatch(updateSettings({
                displayName: defaultLocalDisplayName
            }));
        }
    }, [clientCode, clientId]);
    const handleChangeTileView = (number) => {
        dispatch(setTileViewMode(number));
    };
    const handleOnOff = (isOn = true) => {
        if (isOn)
            return dispatch(sendCommand(COMMANDS.RECORDING.START_RECORDING, Date.now() / 1000, true));
        return dispatch(sendCommand(COMMANDS.RECORDING.START_RECORDING, null, true));
    };
    return (React.createElement(React.Fragment, null, isDevModeOn()
        && conference
        && isShowMenuFake
        && (React.createElement("div", { style: { position: "absolute", top: 0, zIndex: 1000 } },
            React.createElement("p", { onClick: handleAddUser }, "Add user"),
            React.createElement("p", { onClick: handleRemoveUser }, "Remove user"),
            React.createElement("p", { onClick: () => setIsShowMenuFake(false) }, "Close menu"),
            React.createElement("button", { onClick: () => handleChangeTileView(4) }, "4"),
            React.createElement("button", { onClick: () => handleChangeTileView(9) }, "9"),
            React.createElement("button", { onClick: () => handleChangeTileView(16) }, "16"),
            React.createElement("button", { onClick: () => handleChangeTileView(25) }, "25"),
            React.createElement("button", { onClick: () => handleOnOff() }, "ON"),
            React.createElement("button", { onClick: () => handleOnOff(false) }, "OFF")))));
};
export default HandleApp;
function fakeUserInfo() {
    let chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const id = shuffle(sampleSize(chars, 8)).join('');
    return {
        avatarURL: "",
        dominantSpeaker: false,
        email: "fake@gmail.com",
        id: id,
        local: false,
        name: id,
        pinned: false,
        role: "participant",
        startWithAudioMuted: false,
        startWithVideoMuted: false,
        audioOutputDeviceId: "default"
    };
}
